<template>
    <div name="improvement" class="improvement">
        <post
            v-if="isPost"
            @onClose="closePost"
            @onSubmit="submitUncomfortable"
        />
        <div class="inner">
            <improvement-banner 
                @postUncomfortable="postUncomfortable"
            />
            <improvement-list />
        </div>

    </div>
</template>

<script>
import ImprovementList from '@/components/organisms/pc_uncomfortable/ImprovementList'
import ImprovementBanner from '@/components/molecules/pc_uncomfortable/improvements/ImprovementBanner'
import Post from '@/components/organisms/pc_uncomfortable/Post'
import Constant from '@/constant';
import {mapState} from 'vuex'
import CampaignAuth from '@/utilities/campaignAuth';

export default {
    components: { ImprovementList, ImprovementBanner, Post },
    name: 'improvement',
    computed: mapState(['vocPage', 'vocDiabetes', 'vocLoginKakaoToken']),
    data: function()
    {
        return {
            isPost: false
        }
    },
    mounted: function()
    {
        this.$store.commit(Constant.SET_VOC_LOGIN_KAKAO_TOKEN, {token: CampaignAuth.getToken()});

        if(this.$route.query.ispost === "true")
        {
            this.$router.push('/campaign/improvement');
            this.isPost = true;
            // post open
        }
    },
    methods: {
        postUncomfortable: function()
        {
            const token = CampaignAuth.getToken()
            this.$store.commit(Constant.SET_VOC_LOGIN_KAKAO_TOKEN, {token: token});
            if(token === null)
            {
                this.login();
            } else {
                //open 
                this.isPost = true;
            }
            // 유효한 카카오 토큰이 있는지 확인

        },
        login: function()
        {
            CampaignAuth.login(`/campaign/improvement?ispost=true`);
        },
        closePost: function()
        {
            this.isPost = false;
        },
        submitUncomfortable: function(yearCount, contents)
        {
            this.$store.dispatch(Constant.FETCH_DIABETES_VOC_PAGE, {pageno: this.curPage, pagesize: this.pageCount, sort: 'createdAt'})
                .then((res) => {
                    this.totalCount = this.vocPage.totalcount;
                    this.$router.push({path: '/campaign/ranking'})
                })
                .catch((err) => {

                })


            this.isPost = false;

        }
    }
}
</script>

<style scoped>
    .improvement {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        background: linear-gradient(90deg, rgba(192, 212, 237, 0.50) 0.01%, rgba(255, 255, 255, 0.50) 123.04%);
        min-height: 100vh;
        padding-top: 185px;
    }
    .inner {
        width: 1296px;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }
</style>


// WEBPACK FOOTER //
// src/page/pc_uncomfortable/Improvement.vue